import { FC } from 'react'
import { CalendarEvent } from '../../services/calendar'
import CalendarEventRow from './CalendarEventRow'
import { buildListGroups } from './calendar-layout'

interface CalendarListViewProps {
  events: CalendarEvent[]
  periodLabel: string
  onOpenEvent: (event: CalendarEvent) => void
}

const CalendarListView: FC<CalendarListViewProps> = ({ events, periodLabel, onOpenEvent }) => {
  const groups = buildListGroups(events)

  if (groups.length === 0) {
    return (
      <div className="mt-4 rounded-xl border border-slate-200 bg-white p-10 text-center text-sm text-slate-400 shadow-sm">
        Nenhum evento em {periodLabel}.
      </div>
    )
  }

  return (
    <div className="mt-4 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
      <div className="divide-y divide-slate-100">
        {groups.map(group => (
          <div key={group.date} className={`flex gap-4 p-4 ${group.isPast ? 'opacity-60' : ''}`}>
            <div className="w-12 shrink-0 text-center">
              <p
                className={`text-[11px] font-semibold uppercase ${
                  group.isToday ? 'text-secondary-pure' : 'text-slate-400'
                }`}
              >
                {group.weekday}
              </p>
              <p className={`text-2xl font-semibold ${group.isToday ? 'text-secondary-pure' : 'text-slate-700'}`}>
                {group.day}
              </p>
              {group.isToday && <span className="text-[10px] font-medium text-secondary-pure">Hoje</span>}
            </div>
            <div className="flex-1 space-y-2">
              {group.events.map(event => (
                <CalendarEventRow key={`${event.id}-${event.date}`} event={event} onClick={onOpenEvent} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CalendarListView
